import { DataType } from "@src/types/intelligence-search";
import { IconTextSize, IconCalendar, IconToggleLeft, Icon123, IconNumbers } from "@tabler/icons-react";

type GetDataTypeIconProps = {
  type: DataType;
  size?: number;
  color?: string;
};

export const getDataTypeIcon = ({
  type,
  size = 24,
  color = "currentColor",
}: GetDataTypeIconProps): JSX.Element | null => {
  const props = { size, color };

  switch (type) {
    case "string":
      return <IconTextSize {...props} />;
    case "int":
      return <IconNumbers {...props} />;
    case "float":
      return <Icon123 {...props} />;
    case "date":
      return <IconCalendar {...props} />;
    case "bool":
      return <IconToggleLeft {...props} />;
    default:
      console.log("type ", type);
      return null;
  }
};
